export let textColors = {
  Light: {
    divider: 'rgba(255, 255, 255, 0.12)',
    disabled: 'rgba(255, 255, 255, 0.30)',
    secondary: 'rgba(255, 255, 255, 0.70)',
    default: 'rgba(255, 255, 255, 1)'
  },
  Dark: {
    divider: 'rgba(0, 0, 0, 0.12)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    secondary: 'rgba(0, 0, 0, 0.54)',
    default: 'rgba(0, 0, 0, 0.87)'
  }
};

const MuiColors = {
  red: {
    '50': { hex: '#FFEBEE', text: textColors.Dark },
    '100': { hex: '#FFCDD2', text: textColors.Dark },
    '200': { hex: '#EF9A9A', text: textColors.Dark },
    '300': { hex: '#E57373', text: textColors.Dark },
    '400': { hex: '#EF5350', text: textColors.Light },
    '500': { hex: '#F44336', text: textColors.Light },
    '600': { hex: '#E53935', text: textColors.Light },
    '700': { hex: '#D32F2F', text: textColors.Light },
    '800': { hex: '#C62828', text: textColors.Light },
    '900': { hex: '#B71C1C', text: textColors.Light },
    A100: { hex: '#FF8A80', text: textColors.Dark },
    A200: { hex: '#FF5252', text: textColors.Light },
    A400: { hex: '#FF1744', text: textColors.Light },
    A700: { hex: '#D50000', text: textColors.Light }
  },
  pink: {
    '50': { hex: '#FCE4EC', text: textColors.Dark },
    '100': { hex: '#F8BBD0', text: textColors.Dark },
    '200': { hex: '#F48FB1', text: textColors.Dark },
    '300': { hex: '#F06292', text: textColors.Light },
    '400': { hex: '#EC407A', text: textColors.Light },
    '500': { hex: '#E91E63', text: textColors.Light },
    '600': { hex: '#D81B60', text: textColors.Light },
    '700': { hex: '#C2185B', text: textColors.Light },
    '800': { hex: '#AD1457', text: textColors.Light },
    '900': { hex: '#880E4F', text: textColors.Light },
    A100: { hex: '#FF80AB', text: textColors.Dark },
    A200: { hex: '#FF4081', text: textColors.Light },
    A400: { hex: '#F50057', text: textColors.Light },
    A700: { hex: '#C51162', text: textColors.Light }
  },
  purple: {
    '50': { hex: '#F3E5F5', text: textColors.Dark },
    '100': { hex: '#E1BEE7', text: textColors.Dark },
    '200': { hex: '#CE93D8', text: textColors.Dark },
    '300': { hex: '#BA68C8', text: textColors.Light },
    '400': { hex: '#AB47BC', text: textColors.Light },
    '500': { hex: '#9C27B0', text: textColors.Light },
    '600': { hex: '#8E24AA', text: textColors.Light },
    '700': { hex: '#7B1FA2', text: textColors.Light },
    '800': { hex: '#6A1B9A', text: textColors.Light },
    '900': { hex: '#4A148C', text: textColors.Light },
    A100: { hex: '#EA80FC', text: textColors.Dark },
    A200: { hex: '#E040FB', text: textColors.Light },
    A400: { hex: '#D500F9', text: textColors.Light },
    A700: { hex: '#AA00FF', text: textColors.Light }
  },
  deepPurple: {
    '50': { hex: '#EDE7F6', text: textColors.Dark },
    '100': { hex: '#D1C4E9', text: textColors.Dark },
    '200': { hex: '#B39DDB', text: textColors.Dark },
    '300': { hex: '#9575CD', text: textColors.Light },
    '400': { hex: '#7E57C2', text: textColors.Light },
    '500': { hex: '#673AB7', text: textColors.Light },
    '600': { hex: '#5E35B1', text: textColors.Light },
    '700': { hex: '#512DA8', text: textColors.Light },
    '800': { hex: '#4527A0', text: textColors.Light },
    '900': { hex: '#311B92', text: textColors.Light },
    A100: { hex: '#B388FF', text: textColors.Dark },
    A200: { hex: '#7C4DFF', text: textColors.Light },
    A400: { hex: '#651FFF', text: textColors.Light },
    A700: { hex: '#6200EA', text: textColors.Light }
  },
  indigo: {
    '50': { hex: '#E8EAF6', text: textColors.Dark },
    '100': { hex: '#C5CAE9', text: textColors.Dark },
    '200': { hex: '#9FA8DA', text: textColors.Dark },
    '300': { hex: '#7986CB', text: textColors.Light },
    '400': { hex: '#5C6BC0', text: textColors.Light },
    '500': { hex: '#3F51B5', text: textColors.Light },
    '600': { hex: '#3949AB', text: textColors.Light },
    '700': { hex: '#303F9F', text: textColors.Light },
    '800': { hex: '#283593', text: textColors.Light },
    '900': { hex: '#1A237E', text: textColors.Light },
    A100: { hex: '#8C9EFF', text: textColors.Dark },
    A200: { hex: '#536DFE', text: textColors.Light },
    A400: { hex: '#3D5AFE', text: textColors.Light },
    A700: { hex: '#304FFE', text: textColors.Light }
  },
  blue: {
    '50': { hex: '#E3F2FD', text: textColors.Dark },
    '100': { hex: '#BBDEFB', text: textColors.Dark },
    '200': { hex: '#90CAF9', text: textColors.Dark },
    '300': { hex: '#64B5F6', text: textColors.Dark },
    '400': { hex: '#42A5F5', text: textColors.Dark },
    '500': { hex: '#2196F3', text: textColors.Light },
    '600': { hex: '#1E88E5', text: textColors.Light },
    '700': { hex: '#1976D2', text: textColors.Light },
    '800': { hex: '#1565C0', text: textColors.Light },
    '900': { hex: '#0D47A1', text: textColors.Light },
    A100: { hex: '#82B1FF', text: textColors.Dark },
    A200: { hex: '#448AFF', text: textColors.Light },
    A400: { hex: '#2979FF', text: textColors.Light },
    A700: { hex: '#2962FF', text: textColors.Light }
  },
  lightBlue: {
    '50': { hex: '#E1F5FE', text: textColors.Dark },
    '100': { hex: '#B3E5FC', text: textColors.Dark },
    '200': { hex: '#81D4FA', text: textColors.Dark },
    '300': { hex: '#4FC3F7', text: textColors.Dark },
    '400': { hex: '#29B6F6', text: textColors.Dark },
    '500': { hex: '#03A9F4', text: textColors.Dark },
    '600': { hex: '#039BE5', text: textColors.Light },
    '700': { hex: '#0288D1', text: textColors.Light },
    '800': { hex: '#0277BD', text: textColors.Light },
    '900': { hex: '#01579B', text: textColors.Light },
    A100: { hex: '#80D8FF', text: textColors.Dark },
    A200: { hex: '#40C4FF', text: textColors.Dark },
    A400: { hex: '#00B0FF', text: textColors.Dark },
    A700: { hex: '#0091EA', text: textColors.Light }
  },
  cyan: {
    '50': { hex: '#E0F7FA', text: textColors.Dark },
    '100': { hex: '#B2EBF2', text: textColors.Dark },
    '200': { hex: '#80DEEA', text: textColors.Dark },
    '300': { hex: '#4DD0E1', text: textColors.Dark },
    '400': { hex: '#26C6DA', text: textColors.Dark },
    '500': { hex: '#00BCD4', text: textColors.Dark },
    '600': { hex: '#00ACC1', text: textColors.Dark },
    '700': { hex: '#0097A7', text: textColors.Light },
    '800': { hex: '#00838F', text: textColors.Light },
    '900': { hex: '#006064', text: textColors.Light },
    A100: { hex: '#84FFFF', text: textColors.Dark },
    A200: { hex: '#18FFFF', text: textColors.Dark },
    A400: { hex: '#00E5FF', text: textColors.Dark },
    A700: { hex: '#00B8D4', text: textColors.Dark }
  },
  coursio: {
    '50': { hex: '#70FDFF', text: textColors.Dark },
    '100': { hex: '#5CFCFF', text: textColors.Dark },
    '200': { hex: '#47FCFF', text: textColors.Dark },
    '300': { hex: '#1FFBFF', text: textColors.Dark },
    '400': { hex: '#00F1F5', text: textColors.Dark },
    '500': { hex: '#00c9cc', text: textColors.Light },
    '600': { hex: '#00A0A3', text: textColors.Light },
    '700': { hex: '#008C8F', text: textColors.Light },
    '800': { hex: '#006466', text: textColors.Light },
    '900': { hex: '#003C3D', text: textColors.Light },
    A100: { hex: '#5CFCFF', text: textColors.Dark },
    A200: { hex: '#47FCFF', text: textColors.Dark },
    A400: { hex: '#00F1F5', text: textColors.Dark },
    A700: { hex: '#008C8F', text: textColors.Dark }
  },
  teal: {
    '50': { hex: '#E0F2F1', text: textColors.Dark },
    '100': { hex: '#B2DFDB', text: textColors.Dark },
    '200': { hex: '#80CBC4', text: textColors.Dark },
    '300': { hex: '#4DB6AC', text: textColors.Dark },
    '400': { hex: '#26A69A', text: textColors.Dark },
    '500': { hex: '#009688', text: textColors.Light },
    '600': { hex: '#00897B', text: textColors.Light },
    '700': { hex: '#00796B', text: textColors.Light },
    '800': { hex: '#00695C', text: textColors.Light },
    '900': { hex: '#004D40', text: textColors.Light },
    A100: { hex: '#A7FFEB', text: textColors.Dark },
    A200: { hex: '#64FFDA', text: textColors.Dark },
    A400: { hex: '#1DE9B6', text: textColors.Dark },
    A700: { hex: '#00BFA5', text: textColors.Dark }
  },
  green: {
    '50': { hex: '#E8F5E9', text: textColors.Dark },
    '100': { hex: '#C8E6C9', text: textColors.Dark },
    '200': { hex: '#A5D6A7', text: textColors.Dark },
    '300': { hex: '#81C784', text: textColors.Dark },
    '400': { hex: '#66BB6A', text: textColors.Dark },
    '500': { hex: '#4CAF50', text: textColors.Dark },
    '600': { hex: '#43A047', text: textColors.Light },
    '700': { hex: '#388E3C', text: textColors.Light },
    '800': { hex: '#2E7D32', text: textColors.Light },
    '900': { hex: '#1B5E20', text: textColors.Light },
    A100: { hex: '#B9F6CA', text: textColors.Dark },
    A200: { hex: '#69F0AE', text: textColors.Dark },
    A400: { hex: '#00E676', text: textColors.Dark },
    A700: { hex: '#00C853', text: textColors.Dark }
  },
  lightGreen: {
    '50': { hex: '#F1F8E9', text: textColors.Dark },
    '100': { hex: '#DCEDC8', text: textColors.Dark },
    '200': { hex: '#C5E1A5', text: textColors.Dark },
    '300': { hex: '#AED581', text: textColors.Dark },
    '400': { hex: '#9CCC65', text: textColors.Dark },
    '500': { hex: '#8BC34A', text: textColors.Dark },
    '600': { hex: '#7CB342', text: textColors.Dark },
    '700': { hex: '#689F38', text: textColors.Light },
    '800': { hex: '#558B2F', text: textColors.Light },
    '900': { hex: '#33691E', text: textColors.Light },
    A100: { hex: '#CCFF90', text: textColors.Dark },
    A200: { hex: '#B2FF59', text: textColors.Dark },
    A400: { hex: '#76FF03', text: textColors.Dark },
    A700: { hex: '#64DD17', text: textColors.Dark }
  },
  lime: {
    '50': { hex: '#F9FBE7', text: textColors.Dark },
    '100': { hex: '#F0F4C3', text: textColors.Dark },
    '200': { hex: '#E6EE9C', text: textColors.Dark },
    '300': { hex: '#DCE775', text: textColors.Dark },
    '400': { hex: '#D4E157', text: textColors.Dark },
    '500': { hex: '#CDDC39', text: textColors.Dark },
    '600': { hex: '#C0CA33', text: textColors.Dark },
    '700': { hex: '#AFB42B', text: textColors.Dark },
    '800': { hex: '#9E9D24', text: textColors.Dark },
    '900': { hex: '#827717', text: textColors.Light },
    A100: { hex: '#F4FF81', text: textColors.Dark },
    A200: { hex: '#EEFF41', text: textColors.Dark },
    A400: { hex: '#C6FF00', text: textColors.Dark },
    A700: { hex: '#AEEA00', text: textColors.Dark }
  },
  yellow: {
    '50': { hex: '#FFFDE7', text: textColors.Dark },
    '100': { hex: '#FFF9C4', text: textColors.Dark },
    '200': { hex: '#FFF59D', text: textColors.Dark },
    '300': { hex: '#FFF176', text: textColors.Dark },
    '400': { hex: '#FFEE58', text: textColors.Dark },
    '500': { hex: '#FFEB3B', text: textColors.Dark },
    '600': { hex: '#FDD835', text: textColors.Dark },
    '700': { hex: '#FBC02D', text: textColors.Dark },
    '800': { hex: '#F9A825', text: textColors.Dark },
    '900': { hex: '#F57F17', text: textColors.Dark },
    A100: { hex: '#FFFF8D', text: textColors.Dark },
    A200: { hex: '#FFFF00', text: textColors.Dark },
    A400: { hex: '#FFEA00', text: textColors.Dark },
    A700: { hex: '#FFD600', text: textColors.Dark }
  },
  amber: {
    '50': { hex: '#FFF8E1', text: textColors.Dark },
    '100': { hex: '#FFECB3', text: textColors.Dark },
    '200': { hex: '#FFE082', text: textColors.Dark },
    '300': { hex: '#FFD54F', text: textColors.Dark },
    '400': { hex: '#FFCA28', text: textColors.Dark },
    '500': { hex: '#FFC107', text: textColors.Dark },
    '600': { hex: '#FFB300', text: textColors.Dark },
    '700': { hex: '#FFA000', text: textColors.Dark },
    '800': { hex: '#FF8F00', text: textColors.Dark },
    '900': { hex: '#FF6F00', text: textColors.Dark },
    A100: { hex: '#FFE57F', text: textColors.Dark },
    A200: { hex: '#FFD740', text: textColors.Dark },
    A400: { hex: '#FFC400', text: textColors.Dark },
    A700: { hex: '#FFAB00', text: textColors.Dark }
  },
  orange: {
    '50': { hex: '#FFF3E0', text: textColors.Dark },
    '100': { hex: '#FFE0B2', text: textColors.Dark },
    '200': { hex: '#FFCC80', text: textColors.Dark },
    '300': { hex: '#FFB74D', text: textColors.Dark },
    '400': { hex: '#FFA726', text: textColors.Dark },
    '500': { hex: '#FF9800', text: textColors.Dark },
    '600': { hex: '#FB8C00', text: textColors.Dark },
    '700': { hex: '#F57C00', text: textColors.Dark },
    '800': { hex: '#EF6C00', text: textColors.Light },
    '900': { hex: '#E65100', text: textColors.Light },
    A100: { hex: '#FFD180', text: textColors.Dark },
    A200: { hex: '#FFAB40', text: textColors.Dark },
    A400: { hex: '#FF9100', text: textColors.Dark },
    A700: { hex: '#FF6D00', text: textColors.Dark }
  },
  deepOrange: {
    '50': { hex: '#FBE9E7', text: textColors.Dark },
    '100': { hex: '#FFCCBC', text: textColors.Dark },
    '200': { hex: '#FFAB91', text: textColors.Dark },
    '300': { hex: '#FF8A65', text: textColors.Dark },
    '400': { hex: '#FF7043', text: textColors.Dark },
    '500': { hex: '#FF5722', text: textColors.Light },
    '600': { hex: '#F4511E', text: textColors.Light },
    '700': { hex: '#E64A19', text: textColors.Light },
    '800': { hex: '#D84315', text: textColors.Light },
    '900': { hex: '#BF360C', text: textColors.Light },
    A100: { hex: '#FF9E80', text: textColors.Dark },
    A200: { hex: '#FF6E40', text: textColors.Dark },
    A400: { hex: '#FF3D00', text: textColors.Light },
    A700: { hex: '#DD2C00', text: textColors.Light }
  },
  brown: {
    '50': { hex: '#EFEBE9', text: textColors.Dark },
    '100': { hex: '#D7CCC8', text: textColors.Dark },
    '200': { hex: '#BCAAA4', text: textColors.Dark },
    '300': { hex: '#A1887F', text: textColors.Light },
    '400': { hex: '#8D6E63', text: textColors.Light },
    '500': { hex: '#795548', text: textColors.Light },
    '600': { hex: '#6D4C41', text: textColors.Light },
    '700': { hex: '#5D4037', text: textColors.Light },
    '800': { hex: '#4E342E', text: textColors.Light },
    '900': { hex: '#3E2723', text: textColors.Light }
  },
  grey: {
    '50': { hex: '#FAFAFA', text: textColors.Dark },
    '100': { hex: '#F5F5F5', text: textColors.Dark },
    '200': { hex: '#EEEEEE', text: textColors.Dark },
    '300': { hex: '#E0E0E0', text: textColors.Dark },
    '400': { hex: '#BDBDBD', text: textColors.Dark },
    '500': { hex: '#9E9E9E', text: textColors.Dark },
    '600': { hex: '#757575', text: textColors.Light },
    '700': { hex: '#616161', text: textColors.Light },
    '800': { hex: '#424242', text: textColors.Light },
    '900': { hex: '#212121', text: textColors.Light }
  },
  blueGrey: {
    '50': { hex: '#ECEFF1', text: textColors.Dark },
    '100': { hex: '#CFD8DC', text: textColors.Dark },
    '200': { hex: '#B0BEC5', text: textColors.Dark },
    '300': { hex: '#90A4AE', text: textColors.Dark },
    '400': { hex: '#78909C', text: textColors.Light },
    '500': { hex: '#607D8B', text: textColors.Light },
    '600': { hex: '#546E7A', text: textColors.Light },
    '700': { hex: '#455A64', text: textColors.Light },
    '800': { hex: '#37474F', text: textColors.Light },
    '900': { hex: '#263238', text: textColors.Light }
  }
};

export let themeColors = {
  Light: {
    statusBar: '#777777',
    appBar: '#E5E5E5',
    background: '#F2F2F2',
    card: '#FFFFFF'
  },
  Dark: {
    statusBar: '#000000',
    appBar: '#212121',
    background: '#303030',
    card: '#424242'
  }
};

export let Shadow = [
  null,
  '0 1px 3px 0 rgba(0, 0, 0, 0.11)',
  '0 2px 6px 0 rgba(0, 0, 0, 0.06)',
  '0 5px 14px 0 rgba(0, 0, 0, 0.08)',
  '0 2px 24px 0 rgba(0,0,0,.07)'
];

export function hexToRgba(input, opacity) {
  var hex = input.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);

  return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
}

export function brighten(input, percentage) {
  var hex = input.replace('#', '');
  var r = Math.ceil(parseInt(hex.substring(0, 2), 16) * (1 + percentage));
  var g = Math.ceil(parseInt(hex.substring(2, 4), 16) * (1 + percentage));
  var b = Math.ceil(parseInt(hex.substring(4, 6), 16) * (1 + percentage));
  return 'rgba(' + r + ',' + g + ',' + b + ', 1)';
}

const theme = {
  hexToRgba: hexToRgba,
  brighten: brighten,
  Shadow: Shadow,
  Units: {
    base: 8,
    keyline: 64
  },
  Typography: {
    paragraph: {
      fontSize: 14,
      letterSpacing: '0.1px',
      fontFamily: 'MaisonNeue-Book',
      lineHeight: 1.5
    },
    small: {
      fontSize: 12,
      letterSpacing: '0.1px',
      fontFamily: 'MaisonNeue-Demi',
      lineHeight: 1.5
    },
    normal: {
      fontSize: 14,
      letterSpacing: '0.1px',
      fontFamily: 'MaisonNeue-Book',
      lineHeight: 1.5
    },
    subheading: {
      fontSize: 20,
      letterSpacing: '0.5px',
      fontFamily: 'MaisonNeue-Demi',
      lineHeight: 1.5
    },
    heading: {
      fontSize: 32,
      letterSpacing: '0.5px',
      fontFamily: 'MaisonNeue-Demi',
      lineHeight: 1.5
    }
  },
  Colors: {
    material: MuiColors,
    theme: themeColors,
    text: textColors,
    black: '#000000',
    white: '#ffffff',
    creen: '#3bcfd1',
    brightOrange: '#ff5500',
    transparent: 'rgba(0, 0, 0, 0)',
    fullBlack: 'rgba(0, 0, 0, 1)',
    darkBlack: 'rgba(0, 0, 0, 0.87)',
    lightBlack: 'rgba(0, 0, 0, 0.54)',
    minBlack: 'rgba(0, 0, 0, 0.26)',
    faintBlack: 'rgba(0, 0, 0, 0.12)',
    fullWhite: 'rgba(255, 255, 255, 1)',
    darkWhite: 'rgba(255, 255, 255, 0.87)',
    lightWhite: 'rgba(255, 255, 255, 0.54)',
    bondiBlue: '#00C9CC',
    darkBondiBlue: '#004F51',
    bondiBluehover: '#09E4E9'
  }
};

export const Colors = theme.Colors;
export const Units = theme.Units;

export default theme;



// WEBPACK FOOTER //
// ./src/js/Css.js